/**
 * El punto de color de un estado de conversacion.
 *
 * El estado viene de la API con su color elegido por nombre -«green»,
 * «purple»-, asi que esto es DATO, no estilo: un token no sirve porque no hay
 * nueve significados, hay nueve colores que alguien eligio.
 *
 * Vivia dentro del selector, y alli alguien habia cambiado `blue` por
 * `bg-primary` para acallar la regla: el azul dejo de parecerse a los otros
 * ocho y el desplegable quedo con un punto que cambiaba de color con el tema.
 * Por eso esta aqui, declarado, en vez de medio convertido.
 */
/* eslint-disable no-restricted-syntax -- el color de un estado es dato: lo elige quien lo crea y viaja en la API */
export const COLOR_DE_ESTADO: Record<string, string> = {
  green: 'bg-green-500',
  yellow: 'bg-yellow-500',
  orange: 'bg-orange-500',
  blue: 'bg-blue-500',
  gray: 'bg-gray-500',
  purple: 'bg-purple-500',
  red: 'bg-red-500',
  emerald: 'bg-emerald-500',
  amber: 'bg-amber-500',
}

export const COLOR_DE_ESTADO_POR_DEFECTO = 'bg-gray-500'
